import axios from 'axios'
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import React, { useEffect, useState } from 'react';
import { observer } from "mobx-react-lite"
import { Dialog,} from '@radix-ui/themes';
import {
  Route,
  Routes,
  Navigate,
  useParams,
  BrowserRouter as Router,
} from 'react-router-dom';
// api
import BaseApi from './Components/api/BaseApi';
// css
import './App.css';
import './assets/scss/index.scss';
// components
import { Questionary2025 } from './global/barometer/2025-questionnaire'

import Faq from './Components/faq/Faq';
import BlogPage from './Components/blog/BlogPage';
import AboutUs from './Components/aboutUs/AboutUs';
import BarometerPage from './Components/barometer';
import Contact from './Components/contactUs/Contact';
import ForEmployers from './Components/forEmployers';
import ForJobseekers from './Components/forJobseekers';
import TermsOfUse from './Components/contracts/TermsOfUse';
import ManageJob from './Components/employersSide/ManageJob';
import CompanyProfile from './Components/home/CompanyProfile';
import ChangeLogo from './Components/employersSide/ChangeLogo';
import MailDetail from './Components/employersSide/MailDetail';
import DynamicBlogPage from './Components/blog/DynamicBlogPage';
import JobDescription from './Components/element/JobDescription';
import EditProfile from './Components/employersSide/EditProfile';
import MailHistory from './Components/employersSide/MailHistory';
import SearchJobPage from './Components/searchJob/SearchJobPage';
import PrivacyPolicy from './Components/contracts/PrivacyPolicy';
import AdminLogin from './Components/adminpanel/login/AdminLogin';
import Dashboard from './Components/adminpanel/Dashboard/Dashboard';
import APAddSkills from './Components/adminpanel/Skills/APAddSkills';
import BarometerPage2024 from './Components/barometer/barometer2024';
import EmployerRegister from './Components/register/EmployerRegister';
import ChangePassword from './Components/employersSide/ChangePassword';
import APEditSkills from './Components/adminpanel/Skills/APEditSkills';
import APSkillsList from './Components/adminpanel/Skills/APSkillsList';
import JobseekerRegister from './Components/register/JobseekerRegister';
import APAddPlan from './Components/adminpanel/Configuration/APAddPlan';
import DetailEditInner from './Components/employersSide/DetailEditInner';
import APSiteSetting from './Components/adminpanel/Setting/APSiteSetting';
import ImportJobseekers from './Components/employersSide/ImportJobseekers';
import APAddCurrency from './Components/adminpanel/Currency/APAddCurrency';
import APAddEmployer from './Components/adminpanel/Employers/APAddEmployer';
import APAddCategory from './Components/adminpanel/Categories/APAddCategory';
import APCategoryList from './Components/adminpanel/Categories/CategoryList';
import APCurrencyList from './Components/adminpanel/Currency/APCurrencyList';
import APSloganText from './Components/adminpanel/Configuration/APSloganText';
import APChangeLogo from './Components/adminpanel/Configuration/APChangeLogo';
import APEmployerList from './Components/adminpanel/Employers/APEmployerList';
import APChangeEmail from './Components/adminpanel/Configuration/APChangeEmail';
import APAddSubAdmin from './Components/adminpanel/Configuration/APAddSubAdmin';
import InnerMembershipPlan from './Components/employersSide/InnerMembershipPlan';
import APAddJobseekers from './Components/adminpanel/Jobseekers/APAddJobseekers';
import APAddSwearWords from './Components/adminpanel/Swearwords/APAddSwearWords';
import APSubCategoryList from './Components/adminpanel/Categories/SubCategoryList';
import APSMTPsettings from './Components/adminpanel/Configuration/APSMTPsettings';
import APEditSubAdmin from './Components/adminpanel/Configuration/APEditSubAdmin';
import APJobseekerList from './Components/adminpanel/Jobseekers/APJobseekersList';
import APAddSubCategory from './Components/adminpanel/Categories/APAddSubCategory';
import APSwearWordsList from './Components/adminpanel/Swearwords/APSwearWordsList';
import APEditSwearWords from './Components/adminpanel/Swearwords/APEditSwearWords';
import APChangeFavicon from './Components/adminpanel/Configuration/APChangeFavicon';
import APEditEmailSetting from './Components/adminpanel/Setting/APEditEmailSetting';
import APAppliedJobsList from './Components/adminpanel/Jobseekers/APAppliedJobsList';
import APEditSubCategory from './Components/adminpanel/Categories/APEditSubCategory';
import APChangeUsername from './Components/adminpanel/Configuration/APChangeUsername';
import APChangePassword from './Components/adminpanel/Configuration/APChangePassword';
import APMetaManagement from './Components/adminpanel/Configuration/APMetaManagement';
import APAddDesignations from './Components/adminpanel/Designations/APAddDesignations';
import APManageEmailSetting from './Components/adminpanel/Setting/APManageEmailSetting';
import APManageSubAdmins from './Components/adminpanel/Configuration/APManageSubAdmins';
import APManageCertificate from './Components/adminpanel/Jobseekers/APManageCertificate';
import APDesignationsList from './Components/adminpanel/Designations/APDesignationsList';
import APEditDesignations from './Components/adminpanel/Designations/APEditDesignations';
import APSecurityQuestions from './Components/adminpanel/Configuration/APSecurityQuestions';
import APSetContactAddress from './Components/adminpanel/Configuration/APSetContactAddress';
import APEditCurrency from './Components/adminpanel/Currency/APEditCurrency';
import APBannerList from './Components/adminpanel/Banner Advertisement/APBannerList';
import APAddBanner from './Components/adminpanel/Banner Advertisement/APAddBanner';
import APEditBanner from './Components/adminpanel/Banner Advertisement/APEditBanner';
import APCourseList from './Components/adminpanel/Course/APCourseList';
import APAddCourse from './Components/adminpanel/Course/APAddCourse';
import APEditCourse from './Components/adminpanel/Course/APEditCourse';
import APSpecializationList from './Components/adminpanel/Course/APSpecializationList';
import APAddSpecialization from './Components/adminpanel/Course/APAddSpecialization';
import APAddBlog from './Components/adminpanel/Blogs/APAddBlog';
import APEditBlog from './Components/adminpanel/Blogs/APEditBlog';
import APSliderList from './Components/adminpanel/Sliders/APSliderList';
import APAddSlider from './Components/adminpanel/Sliders/APAddSlider';
import APEditSlider from './Components/adminpanel/Sliders/APEditSlider';
import APAnnouncementList from './Components/adminpanel/Announcements/APAnnouncementList';
import APAddAnnouncement from './Components/adminpanel/Announcements/APAddAnnouncement';
import APEditAnnouncement from './Components/adminpanel/Announcements/APEditAnnouncement';
import APTransactionList from './Components/adminpanel/Payment History/APTransactionList';
import APTextPages from './Components/adminpanel/Contents/APTextPages';
import APEditPageDetail from './Components/adminpanel/Contents/APEditPageDetail';
import APSearchKeywordList from './Components/adminpanel/Keywords/APSearchKeywordList';
import APAddSearchKeyword from './Components/adminpanel/Keywords/APAddSearchKeyword';
import APEditSearchKeyword from './Components/adminpanel/Keywords/APEditSearchKeyword';
import APJobKeywordList from './Components/adminpanel/Keywords/APJobKeywordList';
import APAddJobKeyword from './Components/adminpanel/Keywords/APAddJobKeyword';
import APEditJobKeyword from './Components/adminpanel/Keywords/APEditJobKeyword';
import APRequestedKeywordList from './Components/adminpanel/Keywords/APRequestedKeywordList';
import APJobsList from './Components/adminpanel/Jobs/APJobsList';
import APAddJob from './Components/adminpanel/Jobs/APAddJob';
import APEditJob from './Components/adminpanel/Jobs/APEditJob';
import APInternalJobList from './Components/adminpanel/Jobs/APInternalJobList';
import APCopyJob from './Components/adminpanel/Jobs/APCopyJob';
import APImportJob from './Components/adminpanel/Jobs/APImportJob';
import APAutoJobImportList from './Components/adminpanel/Jobs/APAutoJobImportList';
import APNewsletterList from './Components/adminpanel/Manage Newsletter/APNewsletterList';
import APAddNewsletter from './Components/adminpanel/Manage Newsletter/APAddNewsletter';
import APEditNewsletter from './Components/adminpanel/Manage Newsletter/APEditNewsletter';
import APSendNewsLetterEmail from './Components/adminpanel/Manage Newsletter/APSendNewsLetterEmail';
import APEmailLogs from './Components/adminpanel/Manage Newsletter/APEmailLogs';
import APUnsubscribeUserlist from './Components/adminpanel/Manage Newsletter/APUnsubscribeUserlist';
import APEditJobseeker from './Components/adminpanel/Jobseekers/APEditJobseeker';
import Jobseekers from './Components/employersSide/Jobseekers';
import APEmailTemplateSetting from './Components/adminpanel/Email Templates/APEmailTemplateSetting';
import APEditEmployerDetails from './Components/adminpanel/Employers/APEditEmployerDetails';
import APEditSpecializations from './Components/adminpanel/Course/APEditSpecializations';
import APEditPlan from './Components/adminpanel/Configuration/APEditPlan';
import APManageRoles from './Components/adminpanel/Configuration/APManageRoles';
import APEditEmailTemplate from './Components/adminpanel/Email Templates/APEditEmailTemplate';
import APChangeColorTheme from './Components/adminpanel/Configuration/APChangeColorTheme';
import APHomePageSlider from './Components/adminpanel/Employers/APHomePageSlider';
import BlankPage from './Components/element/BlankPage';
import MyProfileNew from './Components/employersSide/MyProfileNew';
import ForgotPassword from './Components/element/ForgotPassword';
import ResetPassword from './Components/element/ResetPassword';
import OfferAgreement from './Components/contracts/OfferAgreement';
import ServiceTerms from './Components/contracts/ServiceTerms';
import UserAgreement from './Components/contracts/UserAgreement';
import DataProcessingConsent from './Components/contracts/DataProcessingConsent';
import EmailConfirmed from './Components/confirmationPages/EmailConfirmed';
import RedirectHandler from './Components/element/RedirectHandler';
import SearchJobPage1 from './Components/searchJob/SearchJobPage1';
import SearchJobPage2 from './Components/searchJob/SearchJobPage2';
import SearchJobPage3 from './Components/searchJob/SearchJobPage3';
import SearchJobPage4 from './Components/searchJob/SearchJobPage4';
import Documents from './Components/employersSide/Documents';
import DHLBrandedPage from './Components/home/brandedPages/DHL/DHLBrandedPage';
import APResumesList from './Components/adminpanel/Resumes/APResumesList';
import APResumeView from './Components/adminpanel/Resumes/APResumeView';
import APEditResume from './Components/adminpanel/Resumes/APEditResume';
import AnketaPage from './Components/anketa';
import SearchByRegion from './Components/searchJob/SearchByRegion';
import APSeoList from './Components/adminpanel/SEO/APSeoList';
import APAddNewSeoInfo from './Components/adminpanel/SEO/APAddNewSeoInfo';
import APRedirectsList from './Components/adminpanel/Redirects/APRedirectsList';
import APAddNewRedirect from './Components/adminpanel/Redirects/APAddNewRedirect';
import FolderPage from 'employer/favorites-page/FavouriteList/FolderPage';
import APActivityList from './Components/adminpanel/Employers/APActivityList';
import ManagersList from './Components/employersSide/ManagersList';
import EditManager from './Components/employersSide/EditManager';

import {Canonical} from 'core/seo/Canonical';
import { Home } from 'global/home';
import { ADMIN_ROUTES } from 'admin/routes';
import { EMPLOYER_ROUTES } from 'employer/routes';
import { useRootStore } from 'core/hooks/use-root-store';
import {ProtectedEmployerRoute} from 'core/access/protected-route'
import { CANDIDATE_ROUTES, CandidateRoutesGuard } from 'candidate';
import { SmsConfirmed } from 'Components/confirmationPages/SmsConfirmed';
import { AuthRoutesGuard } from 'feature-auth/guards';
import { AUTH_ROUTES } from 'feature-auth/routes';

function AppView() {
  const rootStore = useRootStore();
  const tokenKey = Cookies.get('token');
  const adminID = Cookies.get('adminID');
  const GUID = localStorage.getItem('GUID');
  const userType = Cookies.get('user_type');
  const tokenClient = Cookies.get('tokenClient');

  const [captchaKey, setCaptchaKey] = useState(null);
  const [adminAuthentication, setAdminAuthentication] = useState(false);
  const [employerAuthentication, setEmployerAuthentication] = useState(false);
  const [jobseekerAuthentication, setJobseekerAuthentication] = useState(false);

  const checkAdminLogin = () => {
    if (adminID != null && tokenKey != null) {
      setAdminAuthentication(true);
    }
  };

  const checkEmployerLogin = () => {
    if (userType === 'recruiter' && tokenClient) {
      setEmployerAuthentication(true);
      setJobseekerAuthentication(false);
    }
  };

  const checkJobseekerLogin = () => {
    if (userType === 'candidate' && tokenClient) {
      setJobseekerAuthentication(true);
      setEmployerAuthentication(false);
    }
  };

  const getConstantData = async () => {
    try {
      const response = await axios.get(BaseApi + '/getconstant');
      const responseData = response.data.response;

      Cookies.set('curr', responseData.curr);
      Cookies.set('mapKey', responseData.map_key);
      Cookies.set('siteLink', responseData.site_link);
      Cookies.set('siteEmail', responseData.site_email);
      Cookies.set('siteTitle', responseData.site_title);
      Cookies.set('siteFavicon', responseData.site_favicon);
      Cookies.set('primaryColor', responseData.primary_color);
      Cookies.set('captchaKey', responseData.captcha_public_key);
      Cookies.set('secondaryColor', responseData.secondary_color);

      setCaptchaKey(responseData.captcha_public_key);

      // document.title = responseData.site_title;
    } catch (error) {
      console.error('Error getting constant information:', error);
    }
  };

  // const getMetaData = async () => {
  //   try {
  //     const response = await axios.get(BaseApi + '/getMetaData');
  //     const metaKeywords = document.querySelector('meta[name="keywords"]');
  //     const metaDescription = document.querySelector('meta[name="description"]');

  //     if (metaKeywords) {
  //       metaKeywords.content = response.data.response.default_keyword;
  //     }

  //     if (metaDescription) {
  //       metaDescription.content = response.data.response.default_description;
  //     }

  //     Cookies.set('default_title', response.data.response.default_title);
  //     Cookies.set('default_keyword', response.data.response.default_keyword);
  //     Cookies.set('default_description', response.data.response.default_description);
  //   } catch (error) {
  //     console.error('Error getting meta data', error);
  //   }
  // };

  useEffect(() => {
    if (!GUID) {
      localStorage.setItem('GUID', uuidv4());
    }

    getConstantData();
    // getMetaData();
    checkAdminLogin();
    checkEmployerLogin();
    checkJobseekerLogin();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const url = window.location.href;
    // const baseApi = window.location.origin;

    if (url.includes('/users/confirmation')) {
      // console.log("The URL contains email link.");
      const actualURLFirstPart = '/users';
      const secondURLfetch = url.split('/users');
      const actualURLSecondPart = secondURLfetch[1];

      const actualURL = actualURLFirstPart + actualURLSecondPart;
      // console.log(actualURL);
      // window.location.href = actualURL;
      handleMailURL(actualURL);

      // console.log(actualURLSecondPart);
    }
    if (url.includes('/candidates/resetPassword')) {
      // console.log('The URL contains reset link.');
      // eslint-disable-next-line max-len
      const URLSplit = url.split('/candidates/resetPassword'); // This is spliting the total URL into two parts from /candidates. The left side of /candidates has the BASE API and the right side has the remaining link.
      // eslint-disable-next-line max-len
      const URLRightPart = URLSplit[1]; // Here the acctual part of the link is achieved, that is the right part of the link. Now we need to get data from this part of the link

      // console.log(URLRightPart);

      // Remove the leading "/" and split the URL by "/"
      const parts = URLRightPart.slice(1).split('/');

      // Extract values
      const id = parts[0];
      const md5id = parts[1];
      const email = parts[2];

      // console.log('id:', id);
      // console.log('mdid:', md5id);
      // console.log('email:', email);

      // Construct the URL using the dynamic base API
      const resetPasswordURL = `https://grc.com.ua/users/resetPassword/${id}/${md5id}/${email}`;
      // const resetPasswordURL = `${BaseApi}/users/resetPassword/${id}/${md5id}/${email}`;

      // console.log(resetPasswordURL);

      // Use the constructed URL
      window.location.href = resetPasswordURL;

      // window.location.href = `/users/resetPassword/${id}/${md5id}/${email}`;
    }
  }, []);

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [mailURLData, setMailURLData] = useState([]);

  const handleMailURL = async url => {
    try {
      const response = await axios.post(BaseApi + url);

      if (response.data.status === 200) {
        Swal.fire({
          icon: 'success',
          confirmButtonText: 'Close',
          title: response.data.message,
        });
        // Wait for 3 seconds and then redirect
        // setTimeout(() => {
        //   window.location.href = response.data.response.url;
        // }, 2000);
      } else {
        Swal.fire({
          icon: 'error',
          confirmButtonText: 'Close',
          title: response.data.message,
        });
      }

      setMailURLData(response);
    } catch (error) {
      console.error('Error hitting mail URL Api', error);
    }
  };

  const CompanyProfileWrapper = () => {
    const { id } = useParams();

    if (id === '6503') {
      return <DHLBrandedPage />;
    }

    return <CompanyProfile />;
  };

  return (
    <>

      <Router>
        <Canonical/>
        <Routes>
          <Route path='/users/confirmation/:slug1/:slug2/:slug3' element={<BlankPage />} />
          <Route path='//candidates/resetPassword/:slug1/:slug2/:slug3' element={<BlankPage />} />

          {/* Redirects */}
          <Route path='*' element={<RedirectHandler />} />
          <Route path='/ru' element={<Navigate to='/' />} />
          <Route path='/uk/info/data' element={<Navigate to='/' />} />
          <Route path='/article/*' element={<Navigate to='/blog' />} />
          <Route path='/ru/blog/*' element={<Navigate to='/blog' />} />
          <Route path='/search/*' element={<Navigate to='/searchjob' />} />
          <Route path='/employer/*' element={<Navigate to='/searchjob' />} />
          <Route path='/ru/employer/*' element={<Navigate to='/searchjob' />} />
          <Route path='/applicant/*' element={<Navigate to='/auth/employer-login' />} />
          <Route path='/account/login' element={<Navigate to='/auth/employer-login' />} />
          <Route path='/cabinet/help/' element={<Navigate to='/auth/employer-login' />} />
          <Route path='/user/employerlogin' element={<Navigate to='/auth/employer-login' />} />
          <Route path='/user/jobseekerlogin' element={<Navigate to='/auth/candidate-login' />} />

          {/* Main Routes */}
          <Route path='/' element={<Home />} />
          <Route path='/blog' element={<BlogPage />} />
          <Route path='/aboutus' element={<AboutUs />} />
          <Route path='/anketa' element={<AnketaPage />} />
          <Route path='/terms-of-use' element={<TermsOfUse />} />

          {/* <Route path='/searchjob/*' element={<FeatureJobsBrowser />} /> */}

          <Route path='/searchjob' element={<SearchJobPage />} />
          <Route path='/searchjob/:slug1' element={<SearchJobPage1 />} />
          <Route path='/searchjob/:slug1/:slug2' element={<SearchJobPage2 />} />
          <Route path='/searchjob/:slug1/:slug2/:slug3' element={<SearchJobPage3 />} />
          <Route path='/searchjob/:slug1/:slug2/:slug3/:slug4' element={<SearchJobPage4 />} />
     
          <Route path='/barometer-2025-questionnaire' element={<Questionary2025/>}>
          </Route>
          
          <Route path='/foremployers' element={<ForEmployers />} />
          <Route path='/blog/:slug' element={<DynamicBlogPage />} />
          <Route path='/service-terms' element={<ServiceTerms />} />
          <Route path='/barometer' element={<BarometerPage2024 />} />
          <Route path='/forjobseekers' element={<ForJobseekers />} />
          <Route path='/barometer-2025' element={<BarometerPage />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/user-agreement' element={<UserAgreement />} />
          <Route path='/email-confirmed' element={<EmailConfirmed />} />
          <Route path='/sms-confirmed' element={<SmsConfirmed />} />
          <Route path='/offer-agreement' element={<OfferAgreement />} />
          <Route path='/faq' element={<Faq captchaKey={captchaKey} />} />
         
          <Route path='/search-by-cities' element={<SearchByRegion />} />
          <Route path='/search-by-regions' element={<SearchByRegion />} />
          <Route path='/search-by-companies' element={<SearchByRegion />} />
          <Route path='/contact' element={<Contact captchaKey={captchaKey} />} />
          <Route path='/company/:id' element={<CompanyProfileWrapper />} />
          <Route path='/jobdescription/:slug/:catslug' element={<JobDescription />} />
          <Route path='/data-processing-consent' element={<DataProcessingConsent />} />

          <Route element={<AuthRoutesGuard />}>
             {AUTH_ROUTES.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component captchaKey={captchaKey} />} />
            ))}
          </Route>

          {/* Employer */}
          <Route element={<ProtectedEmployerRoute/>}>
             {EMPLOYER_ROUTES.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component />} />
            ))}
          </Route>

          <Route path='/user/documents' element={<Documents />} />
          <Route path='/user/managejob' element={<ManageJob />} />
          <Route path='/user/changelogo' element={<ChangeLogo />} />
          <Route path='/user/myprofile' element={<MyProfileNew />} />
          <Route path='/user/editprofile' element={<EditProfile />} />
          <Route path='/user/mailhistory' element={<MailHistory />} />
          <Route path='/candidates/listing' element={<Jobseekers />} />
       
          <Route path='/company/managers' element={<ManagersList />} />
          
          <Route path='/company/add-manager' element={<EditManager />} />
          <Route path='/user/maildetail/:slug' element={<MailDetail />} />
          <Route path='/plans/purchase' element={<InnerMembershipPlan />} />
          <Route path='/user/changepassword' element={<ChangePassword />} />
          {/* <Route path='/user/paymenthistory' element={<PaymentHistory />} /> */}
          <Route path='/user/favouritelist/:slug' element={<FolderPage />} />
          <Route path='/users/forgotPassword' element={<ForgotPassword />} />
          <Route path='/company/edit-manager/:id' element={<EditManager />} />
          <Route path='/user/importjobseekers' element={<ImportJobseekers />} />
          <Route path='/users/resetPassword/:slug1/:slug2/:slug3' element={<ResetPassword />} />
          <Route path='/user/register/employer' element={<EmployerRegister captchaKey={captchaKey} />} />
          <Route path='/user/register/jobseeker' element={<JobseekerRegister captchaKey={captchaKey} />} />

          {/* Jobseekers */}
         <Route element={<CandidateRoutesGuard/>}>
             {CANDIDATE_ROUTES.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component />} />
            ))}
          </Route>
          
          {/* Admin panel routes */}
          {
            adminAuthentication
              ?  <Route path='/admin' element={<Navigate to='/admin/admins/dashboard' />} />
              :  <Route path='/admin' element={<AdminLogin captchaKey={captchaKey} />} />
          }
          {/* Admin Dashboard */}
          <Route path='/admin/admins/dashboard' element={<Dashboard />} />
          {/* Configuration */}
          <Route path='/admin/plans/addplan' element={<APAddPlan />} />
          {/* <Route path='/admin/plans/index' element={<APManagePlans />} /> */}
          <Route path='/admin/admins/uploadLogo' element={<APChangeLogo />} />
          <Route path='/admin/admins/manage' element={<APManageSubAdmins />} />
          <Route path='/admin/plans/editPlan/:slug' element={<APEditPlan />} />
          <Route path='/admin/admins/addsubadmin' element={<APAddSubAdmin />} />
          <Route path='/admin/admins/changeemail' element={<APChangeEmail />} />
          <Route path='/admin/admins/changeSlogan' element={<APSloganText />} />
          <Route path='/admin/admins/settings' element={<APSetContactAddress />} />
          <Route path='/admin/settings/siteSettings' element={<APSiteSetting />} />
          <Route path='/admin/admins/changeFavicon' element={<APChangeFavicon />} />
          <Route path='/admin/admins/managerole/:slug' element={<APManageRoles />} />
          <Route path='/admin/admins/changepassword' element={<APChangePassword />} />
          <Route path='/admin/admins/changeusername' element={<APChangeUsername />} />
          <Route path='/admin/admins/editadmins/:slug' element={<APEditSubAdmin />} />
          <Route path='/admin/admins/metaManagement' element={<APMetaManagement />} />
          <Route path='/admin/smtpsettings/configuration' element={<APSMTPsettings />} />
          <Route path='/admin/settings/manageMails' element={<APManageEmailSetting />} />
          <Route path='/admin/admins/changecolorscheme' element={<APChangeColorTheme />} />
          <Route path='/admin/settings/editMails/:slug' element={<APEditEmailSetting />} />
          <Route path='/admin/admins/securityQuestions' element={<APSecurityQuestions />} />
          {/* Employer */}
          <Route path='/admin/users' element={<APEmployerList />} />
          <Route path='/admin/users/addusers' element={<APAddEmployer />} />
          <Route path='/admin/users/activity' element={<APActivityList />} />
            {ADMIN_ROUTES.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component />} />
            ))}
          {/* <Route path='/admin/users/selectforslider' element={<HomePageSlider />} /> */}
          {/* <Route path='/admin/blogs' element={<APBlogList />} /> */}
          <Route path='/admin/users/addhomepageslider' element={<APHomePageSlider />} />
          <Route path='/admin/users/editusers/:slug' element={<APEditEmployerDetails />} />
          {/* Jobseeker */}
          <Route path='/admin/candidates' element={<APJobseekerList />} />
          <Route path='/admin/jobs/applied/:slug' element={<APAppliedJobsList />} />
          <Route path='/admin/candidates/addcandidates' element={<APAddJobseekers />} />
          <Route path='/admin/candidates/editcandidates/:slug' element={<APEditJobseeker />} />
          <Route path='/admin/candidates/certificates/:slug' element={<APManageCertificate />} />
          {/* Resumes */}
          <Route path='/admin/resumes' element={<APResumesList />} />
          <Route path='/admin/resumes/:id' element={<APResumeView />} />
          <Route path='/admin/resumes/editResume/:id' element={<APEditResume />} />
          {/* SEO */}
          <Route path='/admin/seo-list' element={<APSeoList />} />
          <Route path='/admin/seo-list/:id' element={<APAddNewSeoInfo />} />
          <Route path='/admin/seo-list/add-new-seo-info' element={<APAddNewSeoInfo />} />
          {/* Redirects */}
          <Route path='/admin/redirects' element={<APRedirectsList />} />
          <Route path='/admin/redirects/:id' element={<APAddNewRedirect />} />
          <Route path='/admin/redirects/add-new-redirect' element={<APAddNewRedirect />} />
          {/* Categories */}
          <Route path='/admin/categories' element={<APCategoryList />} />
          <Route path='/admin/categories/addcategory' element={<APAddCategory />} />
          <Route path='/admin/categories/subindex/:slug' element={<APSubCategoryList />} />
          <Route path='/admin/categories/addsubcat/:slug' element={<APAddSubCategory />} />
          <Route path='/admin/categories/editcategory/:slug' element={<APAddCategory />} />
          <Route path='/admin/categories/editsubcat/:slug1/:slug2' element={<APEditSubCategory />} />
          {/* Swear Words */}
          <Route path='/admin/swears' element={<APSwearWordsList />} />
          <Route path='/admin/swears/addswears' element={<APAddSwearWords />} />
          <Route path='/admin/swears/editswear/:slug' element={<APEditSwearWords />} />
          {/* Skills */}
          <Route path='/admin/skills' element={<APSkillsList />} />
          <Route path='/admin/skills/addskills' element={<APAddSkills />} />
          <Route path='/admin/skills/editskill/:slug' element={<APEditSkills />} />
          {/* Designations */}
          <Route path='/admin/designations' element={<APDesignationsList />} />
          <Route path='/admin/designations/adddesignations' element={<APAddDesignations />} />
          <Route path='/admin/designations/editdesignation/:slug' element={<APEditDesignations />} />
          {/* Jobs */}
          <Route path='/admin/jobs' element={<APJobsList />} />
          <Route path='/admin/jobs/addjob' element={<APAddJob />} />
          <Route path='/admin/jobs/import' element={<APImportJob />} />
          <Route path='/admin/jobs/editjob/:slug' element={<APEditJob />} />
          <Route path='/admin/jobs/addjob/copy/:slug' element={<APCopyJob />} />
          <Route path='/admin/jobs/importlist' element={<APAutoJobImportList />} />
          <Route path='/admin/jobs/candidates/:slug' element={<APInternalJobList />} />
          {/* Payment History */}
          <Route path='/admin/payments/history' element={<APTransactionList />} />
          {/* Currency */}
          <Route path='/admin/currencies' element={<APCurrencyList />} />
          <Route path='/admin/currencies/add' element={<APAddCurrency />} />
          <Route path='/admin/currencies/edit/:slug' element={<APEditCurrency />} />
          {/* Manage Newsletter */}
          <Route path='/admin/newsletters/sentMail' element={<APEmailLogs />} />
          <Route path='/admin/newsletters/index' element={<APNewsletterList />} />
          <Route path='/admin/newsletters/addNewsletter' element={<APAddNewsletter />} />
          <Route path='/admin/newsletters/sendNewsletter' element={<APSendNewsLetterEmail />} />
          <Route path='/admin/newsletters/editNewsletter/:slug' element={<APEditNewsletter />} />
          <Route path='/admin/newsletters/unsubscriberlist' element={<APUnsubscribeUserlist />} />
          {/* Banner Advertisement */}
          <Route path='/admin/banneradvertisements' element={<APBannerList />} />
          <Route path='/admin/banneradvertisements/addBanneradvertisement' element={<APAddBanner />} />
          <Route path='/admin/banneradvertisements/editBanneradvertisement/:slug' element={<APEditBanner />} />
          {/* Course */}
          <Route path='/admin/courses' element={<APCourseList />} />
          <Route path='/admin/courses/addcourse' element={<APAddCourse />} />
          <Route path='/admin/courses/editcourse/:slug' element={<APEditCourse />} />
          <Route path='/admin/specializations/index/:slug' element={<APSpecializationList />} />
          <Route path='/admin/specializations/addspecialization/:slug' element={<APAddSpecialization />} />
          <Route path='/admin/specializations/editspecialization/:slug1/:slug2' element={<APEditSpecializations />} />
          {/* Content */}
          <Route path='/admin/pages/index' element={<APTextPages />} />
          <Route path='/admin/pages/editPage/:slug' element={<APEditPageDetail />} />
          {/* Email Template */}
          <Route path='/admin/emailtemplates' element={<APEmailTemplateSetting />} />
          <Route path='/admin/emailtemplates/editEmailtemplate/:slug' element={<APEditEmailTemplate />}/>
          {/* Blogs */}
          <Route path='/admin/blogs/addblogs' element={<APAddBlog />} />
          <Route path='/admin/blogs/editblogs/:slug' element={<APEditBlog />} />
          {/* Sliders */}
          <Route path='/admin/sliders' element={<APSliderList />} />
          <Route path='/admin/sliders/add' element={<APAddSlider />} />
          <Route path='/admin/sliders/edit/:slug' element={<APEditSlider />} />
          {/* Announcement */}
          <Route path='/admin/announcements' element={<APAnnouncementList />} />
          <Route path='/admin/announcements/add' element={<APAddAnnouncement />} />
          <Route path='/admin/announcements/edit/:slug' element={<APEditAnnouncement />} />
          {/* Keywords */}
          <Route path='/admin/keywords' element={<APSearchKeywordList />} />
          <Route path='/admin/keywords/jobs' element={<APJobKeywordList />} />
          <Route path='/admin/keywords/add' element={<APAddSearchKeyword />} />
          <Route path='/admin/keywords/addjobs' element={<APAddJobKeyword />} />
          <Route path='/admin/keywords/edit/:slug' element={<APEditSearchKeyword />} />
          <Route path='/admin/keywords/editjobs/:slug' element={<APEditJobKeyword />} />
          <Route path='/admin/keywords/requests' element={<APRequestedKeywordList />} />
        </Routes>
      </Router>

          <Dialog.Root
            open={rootStore.globalDialog.opened}
            onOpenChange={(o) => {
              if(o){
                rootStore.globalDialog.open()
              }else {
                rootStore.globalDialog.close()
              }
            }}
          >
            <Dialog.Content {...rootStore.globalDialog.settings} aria-describedby={undefined}>
               {rootStore.globalDialog.render()}
              {rootStore.globalDialog.settings.width}
            </Dialog.Content>
         </Dialog.Root>
    </>
  );
}

export const App = observer(AppView);
